export default __webpack_public_path__ + "static/media/hireYourAI.5262b7c8.svg";